import { createAction } from '@reduxjs/toolkit';
import { ToastProps } from '../interfaces';
import { storeName } from '../config';

export const showToast = createAction<ToastProps>(`${storeName}/showToast`);
